import React, { useMemo } from "react";
import { MapboxDrawOptions } from "@mapbox/mapbox-gl-draw";
import { Typography } from "@mui/material";

import MultiLayerEditPanelContent from "fond/draw/MultiLayerEdit/MultiLayerEditPanelContent";
import { MultiLayerEditProvider } from "fond/draw/MultiLayerEdit/MultiLayerEditProvider";
import {
  DeleteButton,
  LineStringButton,
  PolygonSelectButton,
  RedoButton,
  SelectButton,
  SnappingButton,
  ToolbarConfig,
  TopologicalButton,
  UndoButton,
} from "fond/map/Toolbar";
import { MuPowerSolverLayerIds } from "fond/types";
import { useAppSelector } from "fond/utils/hooks";
import { useStackedNavigationContext } from "fond/widgets";

const toolbarConfig: ToolbarConfig = [
  {
    id: "mainActions",
    type: "mode",
    items: [<SelectButton key="select" />, <PolygonSelectButton key="selectPolygon" />],
  },
  {
    id: "drawTools",
    type: "mode",
    items: [<LineStringButton key="drawLine" />],
  },
  {
    id: "miscTools",
    type: "action",
    items: [<SnappingButton key="snapping" />, <TopologicalButton key="topological" />],
  },
  {
    id: "historyTools",
    type: "action",
    items: [<UndoButton key="undo" />, <RedoButton key="redo" />, <DeleteButton key="delete" />],
  },
];

const MuPowerBlockersDraw: React.FC = () => {
  const versionId = useAppSelector((state) => state.project.versionId);
  const { clear } = useStackedNavigationContext();

  const options: MapboxDrawOptions = useMemo(
    () => ({
      snap: true,
      snapOptions: {
        snapVertexPriorityDistance: 0.000025,
      },
      editOptions: {
        allLayers: [
          {
            ID: MuPowerSolverLayerIds.primaryBlockers,
            GeometryType: "LineString",
            getFeatureProperties: () => ({ layerId: MuPowerSolverLayerIds.primaryBlockers }),
          },
          {
            ID: MuPowerSolverLayerIds.secondaryBlockers,
            GeometryType: "LineString",
            getFeatureProperties: () => ({ layerId: MuPowerSolverLayerIds.secondaryBlockers }),
          },
        ],
        editingLayerId: MuPowerSolverLayerIds.primaryBlockers,
        editingLayerIds: [MuPowerSolverLayerIds.primaryBlockers, MuPowerSolverLayerIds.secondaryBlockers],
      },
    }),
    []
  );

  return (
    <MultiLayerEditProvider versionId={versionId} options={options} config={toolbarConfig}>
      <MultiLayerEditPanelContent
        title="Edit blockers"
        alertTitle="Draw blockers"
        alertBody={<Typography variant="body2">Switch between Primary and Secondary using the layer selector on the map.</Typography>}
        onFinish={clear}
      />
    </MultiLayerEditProvider>
  );
};

export default MuPowerBlockersDraw;
